<template>
  <div class="notice black">
    <div class="layout-content">
      <div class="main">
        <span class="main-title">{{data.title}}</span>

        <div>
          <div class="notice-content-list" v-for="(item, i) in data.list" :key="i">
            <span class="main-id">{{item.id}}</span>
            <span class="main-text">{{item.text}}</span>
          </div>

          <div class="main-wrapper">
            <p class="main-wrapper-place main-wrapper-text">{{data.place}}</p>
            <p class="main-wrapper-text">{{data.time}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.notice {
  padding-top: 66px;

  @include mobile {
    padding-top: 48px;
    padding-bottom: 50px !important;
  }
}

.black {
  height: 360px;
  background: #1B3251;

  @include mobile {
    height: auto;
  }
}

.main {
  display: flex;

  @include mobile {
    flex-direction: column;
  }
}

.main-title {
  margin-right: 76px;
  color: #FFFFFF;
  font-size: 32px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 44px;

  @include mobile {
    font-size: 20px;
  }
}

.notice-content-list {
  width: 960px;
  margin-top: 14px;
  font-size: 15px; font-weight: 400;
  color: #FFFFFF;
  line-height: 32px;

  @include mobile {
    display: flex;
    width: auto;
  }
}

.main-id {
  height: 76px;
  margin-right: 20px;
  color: #FFFFFF;
  font-size: 18px; font-family: DIN-BlackItalic, DIN;
  font-weight: normal;
  line-height: 22px;

  @include mobile {
    margin-right: 10px;
    font-size: 15px;
  }
}

.main-text {
  color: #FFFFFF;
  font-size: 14px; font-weight: 400;
  line-height: 32px;

  @include mobile {
    line-height: 26px;
  }
}

.main-wrapper {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin: 28px 0 108px;
  color: #828A92;
  line-height: 20px;
  font-size: 14px; font-weight: 400;

  @include mobile {
    margin: 28px 0 0;
    font-size: 13px;
  }
}

.main-wrapper-text {
  color: #FFFFFF;
  font-size: 16px; font-weight: 600;
  line-height: 38px;
  @include mobile {
    font-size: 13px;
    line-height: 26px;
  }
}

.main-wrapper-place {
  margin-bottom: 10px;
  @include mobile {
    margin-bottom: 0px;
  }
}

</style>
